// extracted by mini-css-extract-plugin
module.exports = {"root":"badge_root__QAYzu","popIn":"badge_popIn__ksCPm","small":"badge_small__rlRFY"};